import { Component, OnInit, AfterViewInit, Renderer2, OnDestroy, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { appConfig } from 'src/app/_core/config/app-config.const';
import { AuthService } from 'src/app/_services/auth.service';
import { CommonService } from 'src/app/_services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DashboardComponent } from 'src/app/modules/dashboard/dashboard.component';
import { AccountManagementService } from 'src/app/modules/account-management/services/account-management.service';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';
import { environment } from 'src/environments/environment';
import { CommonModalComponent } from 'src/app/shared/components/common-modal/common-modal.component';
import { DownloadModalComponent } from 'src/app/shared/components/download-modal/download-modal.component';
import { BrandingModalComponent } from 'src/app/shared/components/branding-modal/branding-modal.component';
import { ThemeService } from 'src/app/_services/theme.service';
import { BrandingService } from 'src/app/_services/branding.service';
import { NgNavigatorShareService } from 'ng-navigator-share';
import { unlockPremiumComponent } from 'src/app/modules/dashboard/components/unlockPremium/unlockPremium.component';
import { HeaderConfig, BrandingConfig, DEFAULT_HEADER_CONFIG } from 'src/app/_models/header-config.model';
import { AlertModalService } from 'src/app/shared/services/alert-modal.service';

declare let gtag: Function;
declare let $: any;
@Component({
  selector: 'tangram-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  host: {
    '(document:click)': 'onClick($event)',
  },
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  // Inputs from parent (LayoutComponent)
  @Input() config: HeaderConfig = DEFAULT_HEADER_CONFIG;
  @Input() branding: BrandingConfig = { logoUrl: null, bannerUrl: null };

  // Outputs for user actions
  @Output() menuToggle = new EventEmitter<void>();
  @Output() themeToggle = new EventEmitter<void>();

  showSideMenuBar: boolean = false;
  headerFooterCommSubScription: Subscription;
  imgPath = appConfig.imagePath;
  imgEnvPath = environment.backendUrl;
  iconPath = appConfig.iconPath; // To store icon path
  isHomePageSubScription: Subscription;
  currentUserSubscription: Subscription;
  isUserLoggedIn: boolean = false;
  @Output() isPageChange: DashboardComponent;
  pathwayId: string = ""; // To store pathway id
  getPathwaySubscription: Subscription;
  peopleIFollowUsers: any[];
  showFeedbackModal: boolean = false;
  publicVisibility: boolean = false; // To check id public page or not
  currentUser: any;
  isLightMode: boolean = false;
  customThemeActive: boolean = false;
  private effectiveThemeSub: Subscription;
  private brandingSub: Subscription;
  isSticky: boolean = false; // Track sticky state for header background on scroll

  private isMobileDevice: boolean = false;
  private ngNavigatorShareService: NgNavigatorShareService;
  constructor(
    private router: Router,
    private accountService: AccountManagementService,
    private dashboardService: DashboardService,
    private renderer: Renderer2,
    private authservice: AuthService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private themeService: ThemeService,
    private brandingService: BrandingService,
    private cdr: ChangeDetectorRef,
    ngNavigatorShareService: NgNavigatorShareService,
    private alertModalService: AlertModalService,
  ) {
    this.ngNavigatorShareService = ngNavigatorShareService;
    const user = JSON.parse(localStorage.getItem('currentUser'));
    if (user) {
      gtag('event', 'page_visit', {
        'event_category': user._id,
        'event_label': this.router.url
      });
    }
    this.currentUser = user;
  }

  ngOnInit() {
    const details = navigator.userAgent;
    const regexp = /android|iphone|kindle|ipad/i;
    this.isMobileDevice = regexp.test(details);

    if (
        this.activatedRoute.snapshot.routeConfig.path === 'video/:id'
        || this.activatedRoute.snapshot.routeConfig.path === 'dashboard/:pathwayId'
        || this.activatedRoute.snapshot.routeConfig.path === 'configuration'
        || this.activatedRoute.snapshot.routeConfig.path === 'create-tangram'
      ) {
      this.publicVisibility = true;
    }
    this.headerFooterCommSubScription = this.commonService.headerFooterComm.subscribe((param: any) => {
      this.showSideMenuBar = param.flag;
      this.toggleSideMenuBar(param.eventAction);
    });
    this.isHomePageSubScription = this.commonService.isHomeRoute.subscribe((_param: boolean) => {
      // Reserved for future use if needed
    });

    this.currentUserSubscription = this.authservice.currentUser.subscribe((currentUser) => {
      this.isUserLoggedIn = currentUser ? true : false;
      this.currentUser = currentUser || null;
      // Re-enforce the theme whenever auth state changes so a freshly-logged-in
      // free user or a logged-out guest is pinned back to light mode.
      this.enforceThemeMode();
    });
    this.effectiveThemeSub = this.themeService.effective$.subscribe(theme => {
      const wasCustom = this.customThemeActive;
      this.customThemeActive = !!(theme && theme.mode === 'professor');
      // When the custom theme is reset/restored, force light mode so the
      // toggle's sun/moon icon flips to "sun" without waiting for a refresh.
      if (wasCustom && !this.customThemeActive) {
        this.isLightMode = true;
      } else if (theme && theme.mode === 'light') {
        this.isLightMode = true;
      } else if (theme && theme.mode === 'dark') {
        this.isLightMode = false;
      }
    });

    // Listen to branding changes from parent via @Input, but also sync with service
    this.brandingSub = this.brandingService.activeBranding$.subscribe(branding => {
      // Sync with parent-provided branding if not already set
      if (!this.branding.logoUrl && !this.branding.bannerUrl) {
        this.branding = {
          logoUrl: branding && branding.logoUrl ? branding.logoUrl : null,
          bannerUrl: branding && branding.bannerUrl ? branding.bannerUrl : null
        };
      }
      // Add/remove body class when branding banner is active (for sticky header padding)
      if (branding && branding.bannerUrl) {
        this.renderer.addClass(document.body, 'tangram-has-banner');
      } else {
        this.renderer.removeClass(document.body, 'tangram-has-banner');
      }
    });

    // Load the active branding from the API on startup
    this.brandingService.refreshActiveBranding().subscribe();
    // Initialise light-mode state — non-premium users are locked to light;
    // premium users keep their stored preference, defaulting to light when
    // nothing is persisted yet.
    this.enforceThemeMode();
    // Bind pathway id
    this.pathwayId = localStorage.getItem("pathwayId");
    this.getPathwaySubscription = this.commonService.onGetPathway.subscribe((pathwayId) => {
      if (pathwayId) {
        this.pathwayId = pathwayId;
      }
    });

    // Sticky header behavior - gradient background is OFF at top, ON when scrolling
    // HashLocationStrategy is used, so URLs have # prefix (e.g., #/home)
    const normalizedUrl = this.router.url.startsWith('#') ? this.router.url.substring(1) : this.router.url;
    const isHomePage = normalizedUrl === '/home' || normalizedUrl === '/home/';
    if (!isHomePage && !this.isMobileDevice) {
      // Initialize isSticky based on current scroll position
      const initialScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      this.isSticky = initialScrollTop > 10; // Gradient OFF at top, ON when scrolled
      this.cdr.detectChanges();

      this.renderer.listen('window', 'scroll', () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        const shouldHaveGradient = scrollTop > 10; // Gradient OFF at top, ON when scrolled
        if (this.isSticky !== shouldHaveGradient) {
          this.isSticky = shouldHaveGradient;
          this.cdr.markForCheck();
        }
      });
    } else {
      // Home page never has gradient (relies on .top-header--home CSS)
      this.isSticky = false;
      this.cdr.detectChanges();
    }
  }

  ngAfterViewInit(): void {
    // Header padding classes are now managed by LayoutComponent based on route
  }

  ngOnDestroy(): void {
    this.headerFooterCommSubScription ? this.headerFooterCommSubScription.unsubscribe() : '';
    this.currentUserSubscription ? this.currentUserSubscription.unsubscribe() : '';
    this.isHomePageSubScription ? this.isHomePageSubScription.unsubscribe() : '';
    if (this.getPathwaySubscription) {
      this.getPathwaySubscription.unsubscribe();
    }
    if (this.effectiveThemeSub) {
      this.effectiveThemeSub.unsubscribe();
    }
    if (this.brandingSub) {
      this.brandingSub.unsubscribe();
    }
    // Clean up body class
    this.renderer.removeClass(document.body, 'tangram-has-banner');
  }

  toggleLightMode(): void {
    // Dark mode is a premium-only capability. Block non-premium users from
    // switching away from light mode and prompt for an upgrade instead.
    if (this.isLightMode && !this.hasActiveSubscription()) {
      this.openPremiumModal();
      return;
    }
    this.isLightMode = !this.isLightMode;
    this.themeService.persistToggleState(this.isLightMode);

    // Apply mode directly for instant feedback
    const root = document.documentElement;
    const LIGHT_DEFAULTS: Record<string, string> = {
      '--tangram-bg': '#FFFFFF',
      '--tangram-surface': '#F5F5F5',
      '--tangram-text': '#111111',
      '--tangram-header-bg': '#7C3AED',
      '--tangram-header-text': '#FFFFFF',
      '--tangram-primary': '#7C3AED',
      '--tangram-secondary': '#5B21B6',
      '--tangram-accent': '#8B5CF6',
      '--tangram-button': '#7C3AED',
      '--tangram-panel': '#F5F5F5',
    };

    if (this.isLightMode) {
      // Light mode: apply LIGHT_DEFAULTS
      Object.entries(LIGHT_DEFAULTS).forEach(([key, value]) => {
        root.style.setProperty(key, value);
      });
      root.setAttribute('data-tangram-theme', 'active');
      root.setAttribute('data-tangram-mode', 'light');
    } else {
      // Dark mode: remove CSS vars and attributes
      Object.keys(LIGHT_DEFAULTS).forEach(key => {
        root.style.removeProperty(key);
      });
      root.removeAttribute('data-tangram-theme');
      root.removeAttribute('data-tangram-mode');
    }
    // Drop any inline icon filter from a prior custom theme so the SCSS
    // fallback re-applies immediately, without waiting for a page refresh.
    root.style.removeProperty('--tangram-icon-filter');
  }

  /**
   * Toggle side menu bar
   */
  toggleSideMenuBar($event: Event) {
    $event.stopPropagation();
    if (this.showSideMenuBar) {
      this.closeSideMenu();
      return;
    }
    this.showSideMenuBar = true;
    this.renderer.addClass(document.body, 'menu-open');
  }
  /**
   * Open download app modal
   */
  openDownloadAppModal(from = 'download') {
    const modalRef = this.modalService.open(DownloadModalComponent, { centered: true, windowClass: 'modal-small' });
    if (from === 'ios') {
      // For iOS button
      modalRef.componentInstance.selectedOption = 'ios';
    } else if (from === 'android') {
      // For Android button
      modalRef.componentInstance.selectedOption = 'android';
    }
  }
  
  /**
   * Toggle side menu bar when click anywhere
   * @param event
   */
  onClick(event) {
    // Don't close the sidebar while a modal is open — the modal backdrop
    // sits above the sidebar (z-index 1040 > 1031) so clicks on it would
    // otherwise collapse the sidebar behind it.
    if (this.modalService.hasOpenModals()) {
      return;
    }
    if (this.showSideMenuBar) {
      this.toggleSideMenuBar(event);
    } else {
      this.renderer.removeClass(document.body, 'menu-open');
    }
  }

  /**
   * Open people follow modal
   * @param modalContent modalContent to opened as modal
   */
  openPeopleFollowModal(modalContent) {
    this.closeSideMenu();
    const data = {
      page: 1,
      limit: 20
    };
    this.accountService.getPeopleUserFollow(data).subscribe((res: any) => {
      this.peopleIFollowUsers = res.data;
      this.modalService.open(modalContent, { centered: true, windowClass: 'follow-modal' }).result.then(() => {

      }, () => {

      });
    });
  }

  /**
   * Unfollow particular user
   * @param userData unfollow user
   */
  unFollowUser(userData) {
    userData.isFollowed = !userData.isFollowed;
    const data = {
      "_id": userData._id,
      "isFollowed": userData.isFollowed
    };
    this.dashboardService.followUnfollowUser(data).subscribe(() => {
    });

  }

  /**
   * Change view
   * @param viewName viewName to be changed
   */
  changeView(viewName) {
    this.commonService.changeView(viewName);
  }
  openBrandingModal(): void {
    const effectiveTheme = this.themeService.currentTheme;
    const themeId = (effectiveTheme && effectiveTheme.activeThemeId) || '';
    const modalRef = this.modalService.open(BrandingModalComponent, {
      centered: true,
      windowClass: 'modal-dark',
      backdrop: 'static',
    });
    modalRef.componentInstance.themeId = themeId;
    modalRef.result.then((result) => {
      if (result) {
        this.themeService.refreshFromApi().subscribe();
      }
    }, () => {});
  }

  openLogoutConfirm() {
    this.alertModalService.confirm({
      title: 'Log Out',
      message: 'Are you sure you want to log out?',
      cancelText: 'No',
      confirmText: 'Yes, Log Out',
    }).subscribe(confirmed => { if (confirmed) this.doLogout(); });
  }

  doLogout() {
    this.closeSideMenu();
    this.brandingService.clearActiveBranding();
    document.body.classList.remove('tangram-has-banner');
    this.authservice.logout();
    this.router.navigate(["/home"]);
  }


  /**
  * Open feedback modal in small device
  */
  openFeedbackModalInSmallDevice() {
    this.showFeedbackModal = !this.showFeedbackModal;
    $(".feedback-sidebar").appendTo("body");
    $("#feedbackForm").modal("show");
  }

  /**
   * Redirects user to the path given from button
   * @param route Route where user will be redirected
   */
  redirect(route) {
    this.closeSideMenu();
    this.router.navigate([route]);
  }

  /**
   * Go to dashboard
   */
  goToDashboard() {
    this.closeSideMenu();
    this.router.navigate(['/create-tangram']);
    this.commonService.callDashboardEvent(true);
  }

  closeSideMenu(): void {
    this.showSideMenuBar = false;
    this.renderer.removeClass(document.body, 'menu-open');
  }

  isMenuRouteActive(routes: string | string[], exact = false): boolean {
    const currentPath = this.normalizeRoute(this.router.url);
    const routeList = Array.isArray(routes) ? routes : [routes];

    return routeList.some((route) => {
      const normalizedRoute = this.normalizeRoute(route);
      if (exact) {
        return currentPath === normalizedRoute;
      }
      return currentPath === normalizedRoute || currentPath.startsWith(`${normalizedRoute}/`);
    });
  }

  private normalizeRoute(route: string): string {
    const baseRoute = (route || '').split('?')[0].split('#')[0];
    if (!baseRoute) {
      return '/';
    }
    if (baseRoute === '/') {
      return '/';
    }
    return baseRoute.endsWith('/') ? baseRoute.slice(0, -1) : baseRoute;
  }

  /** 
   * Open invite referrel popup
   */
  openShareModal() {    
    const modalRef = this.modalService.open(CommonModalComponent, { centered: true});
    modalRef.componentInstance.data = "Coming Soon: Ability to invite others to the community!";
  }
  navigateToPricing(){
    this.closeSideMenu();
    this.router.navigate(['/home/payment-page']);
  }

  goToSUbscriptionHistory(){
    this.router.navigate(['/home/subscription-history']);
  }

  hasActiveSubscription(): boolean {
    if (!this.currentUser) { return false; }
    return !!this.currentUser.subscriptionActive || this.currentUser.role === 'SUPER_USER';
  }

  /**
   * Ensure the active theme mode matches the current user's entitlements.
   * - Guests and non-premium users are pinned to light mode.
   * - Premium users keep their stored preference, with light as the default
   *   when no preference has been saved yet.
   */
  private enforceThemeMode(): void {
    const storedMode = localStorage.getItem('tangram_active_mode');
    const shouldForceLight = !this.hasActiveSubscription() || !storedMode;

    if (shouldForceLight) {
      this.isLightMode = true;
      this.themeService.persistToggleState(true);
      this.themeService.applyMode('light');
      return;
    }

    this.isLightMode = localStorage.getItem('tangram_light_mode') === '1';
  }

  /** Branding & Customized Theme sidebar links: only for logged-in users whose email contains "admin" (case-insensitive). */
  get showAdminEmailSidebarModules(): boolean {
    if (!this.currentUser || !this.isUserLoggedIn) {
      return false;
    }
    const email = (this.currentUser.email || '').toString().toLowerCase();
    return email.includes('super') || email.includes('sohel');
  }

  /** Admin Analytics menu: super-admin only. */
  get isSuperAdmin(): boolean {
    if (!this.currentUser || !this.isUserLoggedIn) {
      return false;
    }
    return this.currentUser.role === 'SUPER_USER';
  }

  /** User Analytics menu: any logged-in user with an active subscription
   *  (or a super-admin, who bypasses the billing gate). */
  get canSeeUserAnalytics(): boolean {
    return this.isUserLoggedIn && this.hasActiveSubscription();
  }

  openPremiumModal(): void {
    this.modalService.open(unlockPremiumComponent, {
      centered: true,
      windowClass: 'unlock-premium',
    });
  }
}
